import { Link } from "react-router-dom";
import logoFooter from "../assets/logo-footer.svg";
import globe from "../assets/globe.svg";
import usFlag from "../assets/flag_us-en.webp";
import "./footer.css";
import { ToastContainer, toast } from "react-toastify";
import "../assets/ReactToastify.css";

const notify = () => {
  toast.info(
    "This was added only for design purposes, no functionalities included.",
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    }
  );
};

function Footer() {
  return (
    <footer id="footer" className="container-fluid footer wow fadeInUp">
      <div className="footer-top">
        <div className="container">
          <div className="inner-content pb-0">
            <div id="top-footer-row" className="row">
              <div className="col-lg-2 col-md-3 col-12">
                <ul className="ps-0">
                  <li className="d-flex flex-column mb-50">
                    <h6 className="align-self-start mb-20 text-white">
                      Follow Us
                    </h6>

                    <div className="d-flex justify-content-start text-center">
                      <Link className="text-white fs-5" to="#" onClick={notify}>
                        <i className="fa-brands fa-linkedin"></i>
                      </Link>
                      <Link className="text-white fs-5" to="#" onClick={notify}>
                        <i
                          id="instagram-logo"
                          className="fa-brands fa-instagram"
                        ></i>
                      </Link>
                      <Link className="text-white fs-5" to="#" onClick={notify}>
                        <i className="fa-brands fa-facebook"></i>
                      </Link>
                    </div>
                  </li>
                  {/* <li>
                    <div className="footer-logo">
                      <Link to="/">
                        <img id="logo-footer" src={logoFooter} alt="logo" />
                      </Link>
                    </div>
                  </li> */}
                </ul>
              </div>
              <div className="col-lg-5 col-md-3 col-12 d-flex justify-content-center">
                <div className="footer-newsletter w-75">
                  <h4 className="title">
                    LET US SWEETEN YOUR INBOX
                    <span id="span-sweet">
                      Be the first one to know about new products, events,
                      competitions and exciting news.
                    </span>
                  </h4>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-12 newsletter-form-head footer-newsletter">
                <div className="row">
                  <div className="col d-flex justify-content-center p-0">
                    <form target="_blank" className="newsletter-form">
                      <input
                        id="input-newsletter"
                        name="EMAIL"
                        type="email"
                        placeholder="Email address"
                      />
                      <div className="button">
                        <button
                          type="button"
                          onClick={notify}
                          id="button-newsletter"
                          className="btn"
                        >
                          Subscribe<span className="dir-part"></span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-middle pt-3 ">
        <div className="container">
          <div className="bottom-inner">
            <div className="row">
              <div className="text-start col-lg-3 col-md-4 col-12">
                <div className="single-footer f-link">
                  <h3 className="mb-3">Information</h3>
                  <ul className="p-0">
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Delivery Information
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Storefinder
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                id="about-us-div"
                className="text-start col-lg-3 col-md-6 col-12"
              >
                <div className="single-footer f-link">
                  <h3 className="mb-3">About Us</h3>
                  <ul className="p-0">
                    <li>
                      <Link to="#" onClick={notify}>
                        Jobs & Career
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        For Professionals
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Media Corner
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-start col-lg-3 col-md-4 col-12">
                <div className="single-footer f-link">
                  <h3 className="mb-3">Legal</h3>
                  <ul className="p-0">
                    <li>
                      <Link to="#" onClick={notify}>
                        Terms & Conditions
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Cookie Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={notify}>
                        Legal Notice
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-start col-lg-3 col-md-4 col-12">
                <div className="single-footer f-link">
                  <h3 className="mb-3">Shipping country</h3>
                  <ul className="p-0">
                    <li>
                      <Link to="#" onClick={notify}>
                        <img id="globe" src={globe} alt="" />
                      </Link>
                    </li>
                    <h3 className="mb-3 mt-4" onClick={notify}>
                      Language
                    </h3>
                    <span>
                      <img onClick={notify} src={usFlag} alt="us-flag" />
                    </span>
                    <span className="text-white ms-2">EN</span>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
